export default "__VITE_ASSET__DG22dlv0__"